module.exports = __webpack_public_path__ + "img/id_card_back.b487b278.png";